export default {
  error: '錯誤',
  close: '關閉',

  downloadApp: '下載 App',

  loadTextFile: '加載文字字幕',
  lines: '字幕行數：{n} 行',
  startEditing: '開始編輯',
  reactTime: '反應時間：',
  currentLine: '當前字幕',
  emptyHint: '[空]',
  comingLines: '字幕預覽',
  eofHint: '[檔案結束]',
  startReviewing: '開始審查',
  updatePreview: '更新預覽',
  saveSrt: '以 SRT 檔案存儲',
  saveVtt: '以 WebVTT 檔案存儲',
  saveFile: '儲藏檔案',
  loadVideo: '加載影片',

  emptySubtitle: '字幕不能爲空',
  invalidSrt: 'SRT 檔案不合法',

  shortcuts: '操作',
  shortcutK: '切換到下一行',
  shortcutL: '停止當前行',
  shortcutU: '倒帶 3 秒',
  shortcutP: '快轉 3 秒',
  shortcutI: '返回上一行',
  shortcutO: '跳過當前行',
  shortcutR: '暫停 / 播放',
  shortcutQ: '減速播放',
  shortcutE: '加速播放',
};



// WEBPACK FOOTER //
// ./src/i18n/zh-tw.js